import { combineReducers } from "redux";

import { disruptionRootReducer } from "@b2bportal/core-disruption";
import {
  flightsRootReducer,
  flightRtkQueryReducers,
} from "@b2bportal/core-flights";
import { slice } from "@b2bportal/core-flights-cfar-exercise";
import { getApiConfigReducer as tripsApiConfig } from "@hopper-b2b/utilities";
import { reducer as rewards } from "../modules/rewards/reducer";
import { reducer as tripsList } from "../pages/TripsList/reducer";

export const tripsApiConfigStoreKey = "tripsApiConfig";

export const rootReducer = combineReducers({
  tripsList,
  rewards,
  flightsCfarExercise: slice.reducer,
  flights: flightsRootReducer,
  tripsApiConfig: tripsApiConfig(tripsApiConfigStoreKey),
  disruption: disruptionRootReducer,
  ...flightRtkQueryReducers,
});
